import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import {Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment'

@Injectable()
export class CollectionService {

  constructor(private http: HttpClient, public router: Router, private route: ActivatedRoute) { }

  getCollection(token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/api/v2/collection');
  }

  getCollectionByID(id, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/api/v2/collection/' + id, {headers});
  }

  getContent(id, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/api/v2/getContent/' + id, {headers});
  }

  getContentByKeyword(keyword, token) {
    const headers = new HttpHeaders({'Authorization': token});
    return this.http.get( environment.backend + '/api/v2/content/search/' + keyword);
  }

  createCollection(body, token) {
    // const headers = new HttpHeaders({'Authorization': token});
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post( environment.backend + '/api/v2/collection', body, {headers});
  }

  updateCollection(body ,id, token) {
    // const headers = new HttpHeaders({'Authorization': token});
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.put( environment.backend + '/api/v2/collection/' + id, body);
  }

  deleteCollection(id, token) {
    // const headers = new HttpHeaders({'Authorization': token});
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.delete( environment.backend + '/api/v2/collection/' + id);
  }

  addToCollection(collection_id, content_id, token) {
    // const headers = new HttpHeaders({'Authorization': token});
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.post( environment.backend + '/api/v2/addToCollection/' + collection_id, content_id, {headers});
  }

  removeFromCollection(content_id, token) {
    // const headers = new HttpHeaders({'Authorization': token});
    const headers = new HttpHeaders({'Content-Type': 'application/json'});
    return this.http.delete( environment.backend + '/api/v2/removeFromCollection/' + content_id, {headers});
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/collection.service.ts